import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

import { ActivityFormat, NameValue } from '../models';
import { Activity } from '../enums';

import { DatabaseService } from './db-service';
import { environment } from '../../environments/environment';
import { ChoirPerformanceService } from './choir-performance-service';
import { ITPerformanceService } from './it-performance-service';
import { MediaPerformanceService } from './media-performance-service';
import { ResearchPerformanceService } from './research-performance-service';
import { TheatrePerformanceService } from './theatre-performance-service';
import { VisualArtPerformanceService } from './visualArt-performance-service';
import { DateService } from './date-service';

@Injectable({
  providedIn: 'root'
})

export class ActivityFormatService {

    public collection: string = 'activityFormats';

    constructor(
        private angularFirestore: AngularFirestore,
        private choirPerformanceService: ChoirPerformanceService,
        private databaseService: DatabaseService,
        private dateService: DateService,
        private itPerformanceService: ITPerformanceService,
        private mediaPerformanceService: MediaPerformanceService,
        private researchPerformanceService: ResearchPerformanceService,
        private theatrePerformanceService: TheatrePerformanceService,
        private visualArtPerformanceService: VisualArtPerformanceService) {
    }

    /**
     * Get Formats for specific activity
     */
    public getFormatList(activity: NameValue, category?: NameValue, serviceYear: string = environment.serviceYear) {
        if (category != null)
            return this.databaseService.getDocuments(this.collection, ref => ref
                .where('serviceYear', '==', environment.serviceYear)
                .where('activity', '==', activity)
                .where('category', '==', category)
                .where('isActive', '==', true)
                .where('isDeleted', '==', false)
            );
        return this.databaseService.getDocuments(this.collection, ref => ref
            .where('serviceYear', '==', serviceYear)
            .where('activity', '==', activity)
            .where('isActive', '==', true)
            .where('isDeleted', '==', false)
        );
    }

    // CRUD functions
    // Create
    public async createFormat(format: ActivityFormat) {
        format.serviceYear = environment.serviceYear;
        this.angularFirestore.collection(this.collection).add({...format});
    }


    public async migrateFormat(format: ActivityFormat, incrementYears: number) {
        format.serviceYear = environment.serviceYear;

        const id = this.angularFirestore.createId();
        format.id = id;
        
        format = {
            ...format,
            creationStartDate: this.dateService.addYears(incrementYears, format.creationStartDate),
            creationDueDate: this.dateService.addYears(incrementYears, format.creationDueDate),
            membersDueDate: this.dateService.addYears(incrementYears, format.membersDueDate),
            approvalDueDate: this.dateService.addYears(incrementYears, format.approvalDueDate), 
            feeDueDate: this.dateService.addYears(incrementYears, format.feeDueDate),
            uploadDueDate: this.dateService.addYears(incrementYears, format.uploadDueDate),
            linkDueDate: this.dateService.addYears(incrementYears, format.linkDueDate),
            committeeReviewDueDate: this.dateService.addYears(incrementYears, format.committeeReviewDueDate),
            resubmissionDueDate: this.dateService.addYears(incrementYears, format.resubmissionDueDate),
            performanceRolesDueDate: this.dateService.addYears(incrementYears, format.performanceRolesDueDate)
        };

        this.angularFirestore
                .collection(this.collection)
                .doc(id)
                .set(format);
    }

    public getActivityList = (): NameValue[] => {
        const activityList: NameValue[] = [];
        
        activityList.push({ name: Activity.Choir     , value: Activity[Activity.Choir] });
        activityList.push({ name: Activity.IT        , value: Activity[Activity.IT] });
        activityList.push({ name: Activity.Media     , value: Activity[Activity.Media] });
        activityList.push({ name: Activity.Research  , value: Activity[Activity.Research] });
        activityList.push({ name: Activity.Theatre   , value: Activity[Activity.Theatre] });
        activityList.push({ name: Activity.VisualArts, value: Activity[Activity.VisualArts] });

        return activityList; 
    }

    public getActivityCategoryList = (activity: NameValue): NameValue[] => {
        switch (activity.value) {
            case Activity.Choir:
                return this.choirPerformanceService.getPerformanceCategoryList();
            case Activity.IT:
                return this.itPerformanceService.getPerformanceCategoryList();
            case Activity.Media:
                return this.mediaPerformanceService.getPerformanceCategoryList();
            case Activity.Research:
                return this.researchPerformanceService.getPerformanceCategoryList();
            case Activity.Theatre:
                return this.theatrePerformanceService.getPerformanceCategoryList();
            case Activity.VisualArts:
                return this.visualArtPerformanceService.getPerformanceCategoryList();
            default:
                return [];
        }
    }
}
